export default {
  ODOMETER: "Odometer",

  KM: "Kilometer",
  MILES: "Miles",
};
